import { ContentHeaderAction, ContentHeaderProps } from '@b2b/types/core';
import angular from 'angular';
import { PermissionsService } from '../permissions';

export class ContentHeaderService {
  static $inject = ['PermissionsService'];

  title: string | false = false;
  buttonLeft: ContentHeaderProps['buttonLeft'];
  buttonRight: ContentHeaderProps['buttonRight'];
  isLoading = false;

  constructor(private permissionsService: PermissionsService) {}

  init() {
    return true;
  }

  update(props: ContentHeaderProps) {
    this.title = props.title ? props.title : false;
    this.buttonLeft = this.getContentHeaderAction(props.buttonLeft);
    this.buttonRight = this.getContentHeaderAction(props.buttonRight);
  }

  private getContentHeaderAction(action?: ContentHeaderAction) {
    if (action == null) {
      return undefined;
    }

    if (action.permissions) {
      return this.permissionsService.check(action.permissions) ? action : undefined;
    }

    return action;
  }
}

export const ContentHeaderServiceModule = angular
  .module('acme.common.service.contentHeader', ['acme.common.service.permissions'])
  .service('ContentHeaderService', ContentHeaderService).name;
